import React, { useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import * as Config from "../../lib/config";
import { requestFullscreen } from '../../utils/fullscreenHelper';
// import BlurEffectCom from '../../components/blurEffect';

const TextInputSection = (props) => {
    const {
        name,
        setName,
        handleShareUrl,
        assertContentAllowed
    } = props;

    const navigate = useNavigate();
    const hasTrackedFocus = useRef(false);
    const typingTimeoutRef = useRef(null);

    const handleFullScreen = async () => {
        // Local content policy gate before fullscreen (Download uses the same check in App)
        if (assertContentAllowed && !assertContentAllowed('fullscreen')) {
            return;
        }

        try {
            // Enter browser fullscreen mode (like pressing F11)
            await requestFullscreen();
            
            // Track fullscreen action
            if (window.gtag && window.cookieConsentGiven) {
                window.gtag('event', 'fullscreen_enter', {
                    event_category: 'User Engagement',
                    event_label: 'Enter Fullscreen Mode',
                    value: 1
                });
            }
            
            // Navigate to fullscreen view after entering fullscreen
            navigate('/fullscreen-view');
        } catch (error) {
            console.error('Error entering fullscreen:', error);
            // If fullscreen fails, still navigate to fullscreen view
            navigate('/fullscreen-view');
        }
    };

    // Track when user focuses on input field (starts typing) - only if consent is given
    const handleInputFocus = () => {
        if (!hasTrackedFocus.current && window.gtag && window.cookieConsentGiven) {
            hasTrackedFocus.current = true;
            window.gtag('event', 'text_input_focus', {
                event_category: 'User Engagement',
                event_label: 'User Started Typing',
                value: 1
            });
        }
    };

    // Track typing activity (debounced) - privacy-friendly: only track activity, not actual text
    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setName(newValue);
        
        const textLength = newValue.length;
        
        // Clear existing timeout
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }

        // Track typing activity after user stops typing for 1 second (debounced) - only if consent is given
        typingTimeoutRef.current = setTimeout(() => {
            if (window.gtag && window.cookieConsentGiven && textLength > 0) {
                // Determine text length category for privacy
                let lengthCategory = 'short';
                if (textLength > 0 && textLength <= 50) lengthCategory = 'short';
                if (textLength > 50 && textLength <= 100) lengthCategory = 'medium';
                if (textLength > 100 && textLength <= 200) lengthCategory = 'long';
                if (textLength > 200 && textLength <= 300) lengthCategory = 'very_long';

                window.gtag('event', 'text_typing_activity', {
                    event_category: 'User Engagement',
                    event_label: 'Text Input Activity',
                    text_length_category: lengthCategory,
                    text_length: textLength,
                    value: textLength
                });
            }
        }, 1000); // Wait 1 second after user stops typing
    };

    // Handle reset button click
    const handleReset = () => {
        setName('');
        // Track reset action
        if (window.gtag && window.cookieConsentGiven) {
            window.gtag('event', 'text_reset', {
                event_category: 'User Engagement',
                event_label: 'Text Input Reset',
                value: 1
            });
        }
    };

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
        };
    }, []);

    return (
        <>
            <div className='row py-4'>
                <div className='col-12 col-sm-12 col-md-6'>
                    <div className="h-100 w-100 input-field-container">
                        {/*<BlurEffectCom
                            size="40px"
                            FontSize="12px"
                        />
                       <label className="font-16 col-auto pl-0 pl-lg-3">Enter Text: </label> */}
                        {/* <div className="col p-0 h-100"> */}
                        <input 
                            type="text" 
                            className="inputField " 
                            placeholder='Enter Your Text' 
                            value={name} 
                            onFocus={handleInputFocus}
                            onChange={handleInputChange} 
                        />
                        {name && name.trim().length > 0 && (
                            <button 
                                type="button"
                                className="input-reset-btn"
                                onClick={handleReset}
                                aria-label="Reset input field"
                                title="Clear text"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        )}
                        {/* </div> */}
                    </div>
                </div>
                <div className='col-12 col-sm-12  pt-4 col-md-3 pt-md-0 '>
                    <button className="glow-on-hover w-100 centerContain" type="button" onClick={handleShareUrl}>
                        <img
                            src={Config.images.externalLink}
                            alt="right icon"
                            width="100%"
                            className='buttonIcon img-fluid'
                        />
                        Want Share!
                    </button>
                    {/* <div className='col-12 col-sm-12 col-md-6 pr-0 pl-0 pl-md-2 pt-3 pt-md-0'>
                        <button className="reOrderBtn w-100 h-100" type="button">
                        <img
                            src={Config.images.downlaodIcon}
                            alt="right icon"
                            width="100%"
                            className='buttonIcon img-fluid'
                        />
                        Recorder!
                        </button>
                    </div> */}
                </div>
                <div className='col-12 col-sm-12 pt-4 col-md-3 pt-md-0 '>
                    <div className="btnContainer" onClick={handleFullScreen}>
                        <div className="centerContain">
                            <button className="nextBtn">
                                {/* <BlurEffectCom
                                    size="40px"
                                    FontSize="12px"
                                /> */}
                                {/* <svg width="100%" height="60px" viewBox="0 0 180 60" className="border">
                                    <polyline points="179,1 179,59 1,59 1,1 179,1" className="bg-line" />
                                    <polyline points="179,1 179,59 1,59 1,1 179,1" className="hl-line" />
                                </svg> */}
                                <span className='d-flex'>
                                    <div className='fullScreenIcon'>
                                        <img
                                            src={Config.images.fullScreenIcon}
                                            alt="right icon"
                                            width="100%"
                                            className='img-fluid'
                                        />
                                    </div>
                                    <span className='pl-3'>FULL SCREEN</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                .input-field-container {
                    position: relative;
                    display: flex;
                    align-items: center;
                }

                .input-reset-btn {
                    position: absolute;
                    right: 10px;
                    background: rgba(255, 255, 255, 0.1);
                    border: none;
                    border-radius: 50%;
                    width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    color: rgba(255, 255, 255, 0.7);
                    padding: 0;
                    z-index: 10;
                }

                .input-reset-btn:hover {
                    background: rgba(255, 255, 255, 0.2);
                    color: #fff;
                    transform: rotate(90deg);
                }

                .input-reset-btn:active {
                    transform: rotate(90deg) scale(0.9);
                }

                .input-reset-btn svg {
                    width: 18px;
                    height: 18px;
                }

                .inputField {
                    padding-right: 50px !important;
                }

                @media screen and (max-width: 740px) {
                    .centerContain {
                        width: 100%;
                        height: 40px;
                        /* position: absolute; */
                    }

                    .nextBtn {
                        min-height: 40px;
                    }

                    .input-reset-btn {
                        width: 28px;
                        height: 28px;
                        right: 8px;
                    }

                    .input-reset-btn svg {
                        width: 16px;
                        height: 16px;
                    }

                    .inputField {
                        padding-right: 45px !important;
                    }
                }
            `}</style>
        </>
    )
}

export default TextInputSection
